import React, { useCallback, useEffect, useState } from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { LuPencilLine } from "react-icons/lu";
import {
  addSubject,
  deleteSubject,
  editSubject,
  getAllSubject,
  getSingleSubject,
} from "../../redux/services/subjectSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import SubTopic from "./SubTopic";
import SubjectForm from "./subjectForm";
import { useFormik } from "formik";
import * as Yup from "yup";
import { fileUpload } from "../../redux/services/fileUploadSlice";
import { getAllSubTopic } from "../../redux/services/subTopicSlice";
import ConfirmationPage from "../../common/ConfirmationPage";
import Table from "../../common/Table";
import Model from "../../common/Model";

const Subject = () => {
  const dispatch = useDispatch();
  const getSubjectData = useSelector((state) => state?.subject?.subjectData);
  const getSingleSubjectData = useSelector(
    (state) => state?.subject?.singleSubjectData
  );

  const getAllSubTopicDatas = useSelector(
    (state) => state.subTopic.subTopicData
  );
  const [page, setPage] = useState(0);
  const [editId, setEditId] = useState();
  const [confirm, setConfirm] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [preview, setPreview] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const [modelOpen, setModelOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [subTopicData, setSubTopicData] = useState();
  const [subTopicModelOpen, setSubTopicModelOpen] = useState(false);
  const limitOptions = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
  const initialValues = {
    name: "",
    image: "",
    subTopicIds: [],
    isFullLength: false,
    isSubjectShow: false,
  };
  const validationSchema = Yup.object({
    name: Yup.string().required("Subject Name is required"),
    image: Yup.mixed()
      .required("Image is required")
      .test("fileFormat", "Unsupported File Format", (value) => {
        if (value) {
          return true;
        }
        return true;
      }),
    subTopicIds: Yup.array()
      .of(Yup.string().required("Invalid Sub Topic selected"))
      .min(1, "At least one Sub Topic must be selected")
      .required("Sub Topic are required"),
  });
  const getAllSubjectApi = useCallback(async () => {
    try {
      await dispatch(
        getAllSubject({ page: page + 1, limit: pageLimit, searchData })
      );
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData]);
 
  useEffect(() => {
    getAllSubjectApi();
  }, [getAllSubjectApi]);
  const onSubmit = async () => {
    setLoading(true);
    const payload = { ...values };
    if (editId) {
      payload.subjectId = editId;
    }
    try {
      let response;
      if (editId) {
        response = await dispatch(editSubject(payload));
      } else {
        response = await dispatch(addSubject(payload));
      }
      if (response?.payload?.status === 200) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        setLoading(false);
        setModelOpen(false);
        resetForm();
        setEditId();
        setPreview();
        getAllSubjectApi();
      } else {
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setValues,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });
  const handleFileUpload = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    try {
      const response = await dispatch(fileUpload(formData));
      if (response?.payload) {
        setFieldValue("image", response?.payload);
      }
    } catch (error) {
      alert("Error uploading file. Please try again.");
    }
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageURL = URL.createObjectURL(file);
      setPreview(imageURL);
      setFieldValue("image", imageURL);
      handleFileUpload(file);
    }
  };
  useEffect(() => {
    if (modelOpen) {
      const getAllSubTopicData = async () => {
        await dispatch(getAllSubTopic({ page: 1, limit: 300 }));
      };

      getAllSubTopicData();
    }
  }, [modelOpen, dispatch]);
  const deleteSubTopicData = async () => {
    try {
      const response = await dispatch(deleteSubject(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllSubjectApi();
    } catch (error) {}
  };
  const subTopicOptions =
    getAllSubTopicDatas?.sub_topic_data?.map((subTopic) => ({
      value: subTopic._id,
      label: subTopic.name,
    })) || [];
  const getSubjectApi = useCallback(async () => {
    try {
      await dispatch(getSingleSubject(editId));
    } catch (error) {}
  }, [dispatch, editId]);

  useEffect(() => {
    if (editId) {
      getSubjectApi();
    }
  }, [editId, getSubjectApi]);
  useEffect(() => {
    if (getSingleSubjectData) {
      setValues({
        name: getSingleSubjectData.name,
        image: getSingleSubjectData?.image,
        subTopicIds: getSingleSubjectData?.subTopicIds || [],
        isFullLength: getSingleSubjectData?.isFullLength,
        isSubjectShow: getSingleSubjectData?.isSubjectShow,
      });
      setPreview(getSingleSubjectData.image);
    }
  }, [getSingleSubjectData, setValues]);

  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    {
      header: "Subject Name",
      key: "name",
    },

    {
      header: "Sub Topics",
      key: "subTopics",
      render: (_, row) => (
        <button
          className="w-full sm:w-[120px] h-9 bg-primary rounded-xl text-white cursor-pointer"
          onClick={() => {
            setSubTopicModelOpen(true);
            setSubTopicData(row?.subTopics);
          }}
        >
          View
        </button>
      ),
    },
  ];
  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        setModelOpen(true);
        setEditId(row._id);
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];
  return (
    <>
      <Table
        title="Subjects"
        buttonTitle="Add New Subject"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        onAddClick={() => setModelOpen(true)}
        columns={columns}
        data={getSubjectData?.subject_data || []}
        actions={actions}
        onPageChange={(selectedItem) => setPage(selectedItem?.selected)}
        pageCount={getSubjectData?.state?.page_limit}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
      />
      {confirm && (
        <ConfirmationPage
          topicName="Subject"
          confirm={confirm}
          onDelete={deleteSubTopicData}
          onCancel={() => setConfirm(false)}
        />
      )}
      {modelOpen && (
        <SubjectForm
          modelOpen={modelOpen}
          setModelOpen={setModelOpen}
          onClose={() => {
            setModelOpen(false);
            resetForm();
            setPreview();
            setEditId();
          }}
          values={values}
          editId={editId}
          handleChange={handleChange}
          handleBlur={handleBlur}
          errors={errors}
          touched={touched}
          handleSubmit={handleSubmit}
          handleImageChange={handleImageChange}
          setFieldValue={setFieldValue}
          preview={preview}
          loading={loading}
          subTopicOptions={subTopicOptions}
        />
      )}
      <div className="mt-5">
        <SubTopic />
      </div>
      {subTopicModelOpen && (
        <Model
          closeModal={() => setSubTopicModelOpen(false)}
          title="Sub Topics"
        >
          <ul>
            {subTopicData?.map((x, index) => (
              <li className="font-normal mb-2" key={index}>
                - {x?.name}
              </li>
            ))}
          </ul>
        </Model>
      )}
    </>
  );
};

export default Subject;
